<template>
  <div
    class="StepsNav"
    :class="{ 'StepsNav--narrow': depth === 2 }"
  >
    <ul class="StepsNav__list">
      <li
        v-for="(stepItem) in items"
        :key="stepItem.short"
        class="StepsNav__item"
      >
        <div
          class="SNOrb"
          :class="{
            'SNOrb--active': stepItem.short === active,
            jsHover: stepItem.short === hover,
            'SNOrb--available': isAvailable(stepItem.uuid),
            'SNOrb--finished': isCompleted(stepItem.uuid)
          }"
        >
          <span class="SNOrb__label">
            <b-badge variant="dark">
              {{ `${depth === 2 ? stepItem.short.split('-')[1] : stepItem.short }. ${stepItem.label}` }}
            </b-badge>
          </span>
          <span
            class="SNOrb__step"
            @mouseover="setHover(stepItem.short)"
            @mouseleave="setHover(false)"
            @click="setActive(stepItem.uuid, stepItem.short)"
          >{{ depth === 2 ? stepItem.short.split('-')[1] : stepItem.short }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * TODO: This component needs a refactor in variable naming & structure
 * TODO: Currently it has been patched up to do a job, but it's not sustainable code
 */

import { mapGetters } from 'vuex'

export default {
  name: 'StepsNav',
  props: {
    step: {
      type: [String, Number],
      default: 1,
    },
    record: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 1,
      // TODO: Only supports 1 or 2
      validator(value) {
        return [1, 2].includes(value)
      },
    },
  },
  data() {
    return {
      hover: null,
    }
  },
  computed: {
    ...mapGetters('tenant', [
      'getWorkflowSpecByName',
    ]),
    ...mapGetters('processes', [
      'getSkippedStepUuids',
    ]),
    steps() {
      return this.getWorkflowSpecByName({ name: 'realisation' })?.steps || []
    },
    stepsByUuid() {
      return this.steps.reduce((result, step) => {
        result[step.uuid] = step
        return result
      }, {})
    },
    active() {
      // console.log("active", this.step)

      if (this.depth === 1) {
        return (this.step+'').split('-')[0]
      }

      return this.step

      // Used previously to enforce min / max based on available number of steps
      // return Math.max(1, Math.min(this.items.length, parseInt(this.step, 10))) - 1
    },
    parent() {
      if (this.depth === 1) {
        return null
      }
      return (this.step+'').split('-')[0]
    },
    // TODO: Only supports 1 or 2
    items() {
      let childrenByParent = {}
      let children = []
      let root = []

      this.steps.forEach(step => {
        if (step.children) {
          children = children.concat(step.children)
          let parent = ((step.short || step.step) + '').split('-')[0] || 'unknown'
          childrenByParent[parent] = step.children
        }
      })
      this.steps.forEach(step => {
        if (! children.includes(step.uuid)) {
          root.push(step)
        }
      })

      if (this.depth === 1) {
        // console.log("ROOT ITEMS", root)
        return root
      }

      // console.log(this.depth, childrenByParent, this.parent, childrenByParent[this.parent])

      let items = (childrenByParent[this.parent] || []).map(uuid => this.stepsByUuid[uuid])
      // console.log("CHILD ITEMS", items)
      return items

      // return steps.map(step => step.label)
    },
    recordState() {
      try {
        return this.record.flow.state
      } catch (e) {
        return []
      }
    },
    completedUuids() {
      return this.recordState
        .filter(state => state.completed_at)
        .map(state => state.uuid)
    },
    availableUuids() {
      return this.recordState
        .filter(state => state.started_at)
        .map(state => state.uuid)
    },
    isAssetProcess () {
      return this.record.processType?.value !== 'realisation'
    }
  },
  methods: {
    isCompleted(uuid) {
      if (this.getSkippedStepUuids.includes(uuid)) return false
      return this.completedUuids.includes(uuid)
    },
    isAvailable(uuid) {
      if (this.getSkippedStepUuids.includes(uuid)) return false
      return this.availableUuids.includes(uuid)
    },
    setHover(item) {
      if (item) {
        // console.log("hover", item)
        this.hover = item
      } else {
        this.hover = null
      }
    },
    setActive(uuid, short) {
      try {
                // Ignore nav to current page
        if (short === String(this.step)) return

        if (! this.isAvailable(uuid)) return

        const routeType = !this.isAssetProcess ? 'Realisation' : ''

        this.$router.push({
          name: `${routeType}Step${short}`,
          params: {
            step: short,
          },
        })
      } catch (e) {
        // don't do anything
      }
    },
  },
}
</script>

<style lang="scss">
  $orb-size: 30px;
  $orb-size-narrow: 20px;
  $orb-big-scale: 1.5;
  $orb-color: $gray-400;
  $timing: 0.1s;

  $dblue: rgba(4, 30, 66, 0.3);
  $blue: rgba(21, 92, 162, 0.4);
  // $lblue: rgba(59, 146, 229, 0.2);
  $lblue: rgba(4, 30, 66, 0.1);
  $lgreen: rgba(151, 217, 179, 1);
  $green: rgba(67, 177, 115, 1);
  $dgreen: rgba(40, 89, 66, 1);

.StepsNav {
  width: 100%;
  text-align: left;
  user-select: none;
  background: $dblue;
  // background: rgba(0, 0, 0, 0.1);
  padding: 0 2%;

  &--narrow {
    background: $lblue !important;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }
  &__item {
    display: inline-block;
    flex-basis: 100%;
    flex-grow: 1;
    flex-shrink: 1;

    &:first-child,
    &:last-child {
      .SNOrb__label {
        margin: 0;
        transform: none;
      }
      .SNOrb--active {
        .SNOrb__step {
          transform: none;
        }
      }
    }

    &:last-child {
      flex-basis: auto;

      .SNOrb__label {
        right: 0;
      }
      .SNOrb--active {
        .SNOrb__step {
          margin-left: -(($orb-size * $orb-big-scale)-$orb-size)
        }
      }
    }
  }


  // StepsNav Orb
  .SNOrb {
    position: relative;
    align-items: center;
    padding-top: ($orb-size * 0.5);
    padding-bottom: ($orb-size * 0.5);
    transition-property: padding-top, padding-bottom;
    transition-timing-function: ease-in-out;
    transition-duration: $timing;

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 2px;
      width: 100%;
      background-color: $orb-color;
      z-index: -1;
      transition: background-color, $timing;
    }

    &__label {
      position: absolute;
      bottom: 100%;
      color: rgba(0, 0, 0, 0.6);
      display: none;
      margin-left: 0.5 * $orb-size;
      transform: translateX(-50%);
      white-space: nowrap;
    }

    &__step {

      cursor: not-allowed;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 0;
      width: $orb-size;
      height: $orb-size;
      border-radius: $orb-size;
      background-color: $orb-color;
      color: $gray-800;
      font-size: 0.85em;
      font-weight: bold;
      transition-property: width, height, background-color, color, transform, margin-left;
      transition-timing-function: ease-in-out;
      transition-duration: $timing;
    }

    &--available {
      .SNOrb__step {
        cursor: pointer;
        background-color:$gray-800;
        color:white;
      }

      &:before {
        background-color: $gray-800;
      }
    }

    &--active {
      padding: 0;

      .SNOrb__step {
        width: $orb-size * $orb-big-scale;
        height: $orb-size * $orb-big-scale;
        background-color: $gray-800;
        color: white;
        transform: translateX(-0.5 * (($orb-size * $orb-big-scale)-$orb-size));
      }

      .SNOrb__label {
        margin-left: 0.5 * ($orb-size * $orb-big-scale);
      }
    }

    &--finished {
      .SNOrb__step {
        cursor: pointer;
        background-color: #00B46B;
        color:white;
      }

      &:before {
        background-color: #00B46B;
      }
    }

    &.jsHover {
      .SNOrb__label {
        display: inline-block;
      }
    }
  }

  &--narrow {
    padding: 0 4%;
    background: rgba(0, 0, 0, 0.025);

    .StepsNav {
      &__item {
        &:last-child {
          .SNOrb--active {
            .SNOrb__step {
              margin-left: -(($orb-size-narrow * $orb-big-scale)-$orb-size-narrow)
            }
          }
        }
      }
    }
    .SNOrb {
      text-transform: lowercase;
      padding-top: ($orb-size-narrow * 0.25);
      padding-bottom: ($orb-size-narrow * 0.25);

      &__label {
        margin-left: 0.5 * $orb-size-narrow;
        text-transform: none;
      }
      &__step {
        width: $orb-size-narrow;
        height: $orb-size-narrow;
        border-radius: $orb-size-narrow;
      }

      &--active {
        .SNOrb__label {
          margin-left: 0.5 * ($orb-size-narrow * $orb-big-scale);
        }
        .SNOrb__step {
          width: $orb-size-narrow * $orb-big-scale;
          height: $orb-size-narrow * $orb-big-scale;
          transform: translateX(-0.5 * (($orb-size-narrow * $orb-big-scale)-$orb-size-narrow));
        }
      }
    }
  }
}

</style>
